const QUERY_PARAM = "employer";
const STORAGE_KEY = "pencom:employer-bypass";

const DEFAULT_TOKEN = "pencom-employer-7d3a2f9c1e8b4a6d0f2c5e9a3b7d1f8c";

const getActiveToken = (): string => DEFAULT_TOKEN;

export const consumeEmployerBypassFromUrl = (): void => {
  if (typeof window === "undefined") return;

  const url = new URL(window.location.href);
  const provided = url.searchParams.get(QUERY_PARAM);
  if (!provided) return;

  if (provided === getActiveToken()) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, "1");
    } catch {
      return;
    }
  }

  url.searchParams.delete(QUERY_PARAM);
  const cleaned = url.pathname + (url.search ? url.search : "") + url.hash;
  window.history.replaceState({}, "", cleaned);
};

/** Returns the URL an employer can visit to bypass maintenance mode. */
export const getEmployerBypassUrl = (): string =>
  `${window.location.origin}/?${QUERY_PARAM}=${getActiveToken()}`;

export const isQaBypassActive = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};
